import { StringKey } from '../lang/index';
import { getTranslation } from './get-translation.util';

export function formatBytes(bytes: number) {
  if (!+bytes) return '0';

  const k = 1024;
  const sizes = ['SIZE_B', 'SIZE_KB', 'SIZE_MB', 'SIZE_GB'] as unknown as StringKey[];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed())} ${getTranslation(sizes[i])}`;
}
